import { DashboardLayout } from "@/components/dashboard-layout";
import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import { Aperture, FileCog } from "lucide-react";
import { Card } from "@/components/ui/card";
import { CardContent } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { organisationsQueryOptions } from "@/server/organisations";
import { SubmenuItem } from "@/components/submenu";
import { useMemo } from "react";

export const Route = createFileRoute("/_dashboard/emails")({
  component: EmailsRouteComponent,
  beforeLoad: () => ({
    title: "Emails",
  }),
  loader: async () => ({
    crumb: "Emails",
  }),
});

function EmailsRouteComponent() {
  const matches = useMatches();
  const hasChildRoute = matches[matches.length - 1].fullPath !== "/emails";

  const organisationsQuery = useQuery(organisationsQueryOptions());
  const organisations = organisationsQuery.data || [];

  const submenuItems: SubmenuItem[] = useMemo(
    () => [
      {
        id: 1,
        name: "System",
        href: "/emails/system",
        icon: <FileCog className="h-4 w-4" />,
        isParent: false,
      },
      {
        id: 2,
        name: "Organisations",
        href: "/emails/organisations",
        icon: <Aperture className="h-4 w-4" />,
        isParent: true,
        children: organisations?.map((organisation: any) => ({
          id: organisation.id,
          name: organisation.name,
          href: `/emails/organisations/${organisation.id}`,
        })),
      },
    ],
    [organisations]
  );

  return (
    <DashboardLayout
      submenu={{
        items: submenuItems || [],
        isLoading: organisationsQuery.isLoading,
        title: "Emails",
        active: true,
        placeholder: "Search resources...",
      }}
    >
      {!hasChildRoute ? (
        <Card>
          <CardContent>
            <p className="text-md pb-20 pt-15 text-center">
              Please select an email resource from the submenu to view its details or manage it.
            </p>
          </CardContent>
        </Card>
      ) : (
        <Outlet />
      )}
    </DashboardLayout>
  );
}
